import React, { Component }  from 'react';
import { withRouter }        from 'react-router';
import { connect }           from 'react-redux';
import { Redirect }          from 'react-router-dom';
import ConnectBreadcrumb     from './Breadcrumb';
import UserLanding           from './User/UserLanding';
import AdminLanding          from './Admin/AdminLanding';
import SettingsLanding       from './Admin/SettingsLanding';
import { ConnectConstants }  from './environment';
import { isInRoleFromToken } from '../../../utils/authService';
import Required              from '../../Required';
import { isLoggedIn }        from '../../../utils/authService';
import { redirect }          from '../../../utils/authService'; 

class Template extends Component {
  
  componentDidMount() {
    document.title = document.title.split("|")[0] + ' | Live Chat';
  }

  render() {
    const path   = this.props.location.pathname.toLowerCase();   
    const search = window.location.hash;
    const hashes = search.slice(search.indexOf('?') + 1).split('&');
    const params = {};
    hashes.map(hash => {
      const [key, val] = hash.split('=');
      params[key.toLowerCase()] = decodeURIComponent(val);
      return params;
    });
    
    var login = params['login'];
    console.log('login query = ' + login);
    
    var chat = params['chat'];
    console.log('chat query = ' + chat);

    if (!isLoggedIn() && path.startsWith(ConnectConstants.AdminPathPrefix)) {
      redirect(window.location.hash.replace("#/", ""));
      return (
        <Required />
      );
    }
    
    if (!isLoggedIn() && 'login' in params) {
      var redir = window.location.hash.replace("#/", "");
      if ('login' in params) {
        var rLink = redir.split("?")[0];
        if ('chat' in params) {  
          rLink += '?chat=' + chat;
        }
        
        redirect(rLink);
      }
      else {
        redirect(redir);
      }
      return (
        <Required />
      );
    }

    let content = null;
    if (isInRoleFromToken(ConnectConstants.AdminRole)) {
      let component = null;
      if (path.endsWith(ConnectConstants.PathPrefix)) {
        component = <UserLanding />;
      }
      else if (path.startsWith(ConnectConstants.AdminPathPrefix + '/settings')) {
        component = <SettingsLanding />;
      }
      else if (path.startsWith(ConnectConstants.AdminPathPrefix)) {
        component = <AdminLanding />;
      }
      else {
        // No idea what path here
      }
      
      content = 
        <div>
          <ConnectBreadcrumb {...this.props} />
          {component}
        </div>;
    }
    else if (ConnectConstants.UserRole === "*" || isInRoleFromToken(ConnectConstants.UserRole)) {
      let component = null;
      if (path.endsWith(ConnectConstants.PathPrefix)) {
        component = <UserLanding />;
      }
      else if (path.startsWith(ConnectConstants.UserPathPrefix)) {
        component = <UserLanding />;
      }
      else {
        // No idea what path here
      }
      
      content = 
        <div>
          <ConnectBreadcrumb {...this.props} />
          {component}
        </div>;
    }
    else {
      return <Redirect to='/404' />;
    }

    return (
      <div>
        {content}
      </div>
    );
  }
}

const mapStateToProps = state => ({ 
  template: state.template
});

export default withRouter(connect(mapStateToProps)(Template));
